const template = require('./dateRange.template');
const MILLISECONDS_PER_DAY =  1000 * 3600 * 24;
interface DateRange {
	startDate:Date; 
	endDate:Date;
}

export default class DateRangePicker implements ng.IComponentController{
	public static $inject = [
	];

	public readonly today = new Date();
	public dayRange:number;
	public startDate:Date;
    public endDate:Date;
	public onChange:(range:DateRange) => void;

	constructor(){
		if(!this.endDate){
			this.endDate = new Date();
		}

		if(!this.startDate){
			this.startDate = new Date();
			this.startDate.setDate(this.endDate.getDate() - this.dayRange);
		}
	}

	public changeDate(){
		let changeObject = {
			startDate: this.startDate,
			endDate: this.endDate
		};
		
		if (!this.validDateRange) {
			changeObject = {
				startDate: null,
				endDate: null
			};
		}

		this.onChange(changeObject);
	}

	public get validDateRange() {
		if(!this.dayRange || this.dayRange < 1){
			return true;
		}
		else if (!this.endDate || !this.startDate) {
			return false;
		}

		let dateRangeDays = (this.endDate.getTime() - this.startDate.getTime()) / MILLISECONDS_PER_DAY;
        return Math.ceil(dateRangeDays) <= this.dayRange;
	}
}

export const DateRangePickerComponent:ng.IComponentOptions  =  {
	template,
	controller: DateRangePicker,
	controllerAs:'vm',
	bindings: {
		dayRange: '<',
		startDate: '<',
		endDate: '<',
		onChange: '&'
	}
};


// WEBPACK FOOTER //
// ./src/sharebase/components/dateRange/dateRange.component.ts